import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[integerOnly]'
})
export class IntegerOnlyDirective {
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const invalidKeys = ['.', ',', 'e', 'E', '+', '-'];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    // Remove any floating-point characters if pasted or entered via other means
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
  }
}